/**
 * Where a customer invite notification opens: the customer, whose Details tab
 * shows the invite and any changes they sent. Shared by NotificationBell and
 * usePushNotifications so the two agree.
 */
export function customerInviteNotificationPath(type: string | undefined, data?: Record<string, string>): string | null {
  if (type !== 'customer_details_received' && type !== 'customer_invite_accepted') return null;
  return data?.customer_id ? `/customers/${data.customer_id}` : '/customers';
}
